import { render, staticRenderFns } from "./Anzan.vue?vue&type=template&id=ec8ac864&lang=pug&"
import script from "./Anzan.vue?vue&type=script&lang=js&"
export * from "./Anzan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports